import React, { Component } from "react";
import { branch, root } from "baobab-react/higher-order";
import PropTypes from "baobab-react/prop-types";
import autoBind from "react-autobind";
import { Alert, Button, FormControl } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-responsive-modal";

import { Page } from "../shared/";
import DriveWrapper from "./driveWrapper";
import browserHistory from "../../history";
import { handlePageInit } from "../../utils/securityUtil";
import { getActivityMetadata } from "../../actions/playerActions";
import state from "../../state/state";
import PlayerPaths from "../../constants/paths/playerPaths";
import {
	discoverSkuPhotoMappingActivityCandidates,
	findSkuPhotoMappingActivityById,
	getSkuPhotoMappingLaunchPath,
	isSkuPhotoMappingOrganization,
	mergeSkuPhotoMappingActivityMetadata
} from "../player/skuPhotoMappingMode";
// import { handleSave } from "../../actions/drive";

export class DrivePage extends Component {

	constructor(props) {
		super(props);
		handlePageInit(this.props.location, false, true);
		this.state = {
			showModal: false,
			skuPhotoMappingActivityId: "",
			skuPhotoMappingPickerOpen: false,
			skuPhotoMappingPickerStatus: "idle",
			skuPhotoMappingPickerActivities: [],
			skuPhotoMappingPickerError: "",
			skuPhotoMappingPickerWarning: "",
			skuPhotoMappingPickerProgress: null
		};
		this.skuPhotoMappingDiscoveryRequestId = 0;
		this.skuPhotoMappingMetadataCache = new Map();
		autoBind(this);
	}

	handleOpenSkuPhotoMappingWorkbench() {
		const activity = this.getSelectedSkuPhotoMappingActivity();
		if (activity && activity.id) {
			try {
				state.set(
					["activities"],
					mergeSkuPhotoMappingActivityMetadata(state.get(["activities"]), activity)
				);
				state.set(
					PlayerPaths.ACTIVITIES,
					mergeSkuPhotoMappingActivityMetadata(state.get(PlayerPaths.ACTIVITIES), activity)
				);
				browserHistory.push(getSkuPhotoMappingLaunchPath(activity.id));
			} catch (err) {
				this.setState({
					skuPhotoMappingPickerStatus: "error",
					skuPhotoMappingPickerError: "The workbench could not be opened. Please try again."
				});
			}
		}
	}

	handleSkuPhotoMappingActivityChange(event) {
		this.setState({ skuPhotoMappingActivityId: event.target.value });
	}

	handleShowSkuPhotoMappingPicker() {
		if (!isSkuPhotoMappingOrganization(this.props.selectedOrgId)) {
			return;
		}
		this.setState({
			skuPhotoMappingPickerOpen: true,
			skuPhotoMappingPickerStatus: "loading",
			skuPhotoMappingActivityId: "",
			skuPhotoMappingPickerError: "",
			skuPhotoMappingPickerWarning: "",
			skuPhotoMappingPickerProgress: null
		}, this.loadSkuPhotoMappingActivities);
	}

	handleCloseSkuPhotoMappingPicker() {
		this.skuPhotoMappingDiscoveryRequestId += 1;
		this.setState({ skuPhotoMappingPickerOpen: false });
	}

	handleRetrySkuPhotoMappingDiscovery() {
		this.setState({
			skuPhotoMappingPickerStatus: "loading",
			skuPhotoMappingActivityId: "",
			skuPhotoMappingPickerError: "",
			skuPhotoMappingPickerWarning: "",
			skuPhotoMappingPickerProgress: null
		}, this.loadSkuPhotoMappingActivities);
	}

	getSkuPhotoMappingActivityMetadata(activity) {
		const activityId = `${(activity && activity.id) || ""}`.trim();
		const revisionKey = `${activityId}:${activity.revisionTs || activity.revision || activity.updatedAt || ""}`;
		if (this.skuPhotoMappingMetadataCache.has(revisionKey)) {
			return this.skuPhotoMappingMetadataCache.get(revisionKey);
		}
		const request = getActivityMetadata(activityId).catch((err) => {
			if (this.skuPhotoMappingMetadataCache.get(revisionKey) === request) {
				this.skuPhotoMappingMetadataCache.delete(revisionKey);
			}
			throw err;
		});
		this.skuPhotoMappingMetadataCache.set(revisionKey, request);
		return request;
	}

	async loadSkuPhotoMappingActivities() {
		const activities = this.props.activities;
		if (!Array.isArray(activities)) {
			this.setState({
				skuPhotoMappingPickerStatus: "error",
				skuPhotoMappingPickerError: "Activities could not be loaded. Close this dialog and try again."
			});
			return;
		}
		if (activities.length === 0 && this.props.activitiesLoaded === false) {
			this.setState({
				skuPhotoMappingPickerStatus: "loading",
				skuPhotoMappingPickerProgress: null
			});
			return;
		}

		const requestId = this.skuPhotoMappingDiscoveryRequestId + 1;
		this.skuPhotoMappingDiscoveryRequestId = requestId;
		try {
			const result = await discoverSkuPhotoMappingActivityCandidates(
				activities,
				this.getSkuPhotoMappingActivityMetadata,
				{
					concurrency: 6,
					onProgress: (progress) => {
						if (requestId === this.skuPhotoMappingDiscoveryRequestId) {
							this.setState({ skuPhotoMappingPickerProgress: progress });
						}
					}
				}
			);
			if (requestId !== this.skuPhotoMappingDiscoveryRequestId) {
				return;
			}

			const pickerActivities = result.activities || [];
			const selectedActivity = pickerActivities.length === 1 ? pickerActivities[0] : null;
			const partialWarning = result.failureCount > 0 && pickerActivities.length > 0
				? `${result.failureCount} activit${result.failureCount === 1 ? "y" : "ies"} could not be inspected and may be missing from this list.`
				: "";
			this.setState({
				skuPhotoMappingPickerActivities: pickerActivities,
				skuPhotoMappingActivityId: selectedActivity ? selectedActivity.id : "",
				skuPhotoMappingPickerStatus: pickerActivities.length > 0
					? "ready"
					: (result.failureCount > 0 ? "error" : "empty"),
				skuPhotoMappingPickerError: pickerActivities.length === 0 && result.failureCount > 0
					? `Unable to inspect ${result.failureCount} activit${result.failureCount === 1 ? "y" : "ies"}. Check your connection and try again.`
					: "",
				skuPhotoMappingPickerWarning: partialWarning,
				skuPhotoMappingPickerProgress: null
			});
		} catch (err) {
			if (requestId !== this.skuPhotoMappingDiscoveryRequestId) {
				return;
			}
			this.setState({
				skuPhotoMappingPickerStatus: "error",
				skuPhotoMappingPickerError: "Eligible activities could not be discovered. Check your connection and try again.",
				skuPhotoMappingPickerProgress: null
			});
		}
	}

	getSkuPhotoMappingActivityDate(activity = {}) {
		const timestamp = activity.revisionTs || activity.updatedAt || activity.modifiedAt || activity.createdAt;
		if (!timestamp) {
			return "";
		}
		const date = new Date(timestamp);
		return Number.isNaN(date.getTime()) ? "" : date.toLocaleDateString();
	}

	getSkuPhotoMappingActivityOptionLabel(activity = {}) {
		const name = activity.name || activity.title || activity.id;
		const details = [
			activity.version ? `v${activity.version}` : "",
			activity.revision ? `revision ${activity.revision}` : "",
			this.getSkuPhotoMappingActivityDate(activity)
		].filter(Boolean);
		return details.length > 0 ? `${name} — ${details.join(" · ")}` : name;
	}

	getSelectedSkuPhotoMappingActivity() {
		return findSkuPhotoMappingActivityById(
			this.state.skuPhotoMappingPickerActivities,
			this.state.skuPhotoMappingActivityId
		);
	}

	renderSkuPhotoMappingPicker() {
		const {
			skuPhotoMappingPickerOpen,
			skuPhotoMappingPickerStatus,
			skuPhotoMappingPickerActivities,
			skuPhotoMappingPickerError,
			skuPhotoMappingPickerWarning,
			skuPhotoMappingPickerProgress
		} = this.state;
		const selectedActivity = this.getSelectedSkuPhotoMappingActivity();
		const loadingProgress = skuPhotoMappingPickerProgress && skuPhotoMappingPickerProgress.totalCount > 0
			? ` Checked ${skuPhotoMappingPickerProgress.completedCount} of ${skuPhotoMappingPickerProgress.totalCount}.`
			: "";
		const selectedActivityTags = selectedActivity && Array.isArray(selectedActivity.tags)
			? selectedActivity.tags.map((tag) => `${(tag && (tag.name || tag.value || tag.id)) || tag || ""}`.trim()).filter(Boolean)
			: [];
		const selectedActivityDetails = selectedActivity ? [
			selectedActivity.version ? `Version ${selectedActivity.version}` : "",
			selectedActivity.revision ? `Revision ${selectedActivity.revision}` : "",
			this.getSkuPhotoMappingActivityDate(selectedActivity)
				? `Updated ${this.getSkuPhotoMappingActivityDate(selectedActivity)}`
				: ""
		].filter(Boolean) : [];

		return <Modal
			open={skuPhotoMappingPickerOpen}
			onClose={this.handleCloseSkuPhotoMappingPicker}
			classNames={{ modal: "custom-modal sku-photo-mapping-activity-picker" }}
			center
			closeButton
		>
			<div style={{ width: "min(620px, calc(100vw - 72px))", maxWidth: "100%" }}>
				<h3 style={{ margin: "0 0 6px" }}>Open SKU Photo Mapping</h3>
				<p style={{ color: "#5f6b76", margin: "0 0 18px", lineHeight: 1.45 }}>
					Choose an activity whose Price List contains the SKUs you want to map to Drive photos.
				</p>

				{skuPhotoMappingPickerStatus === "loading" && <div role="status" style={{ padding: "22px 4px", color: "#4b5563" }}>
					<FontAwesomeIcon icon="spinner" spin style={{ marginRight: 8 }} />
					Loading and checking activities...{loadingProgress}
				</div>}

				{skuPhotoMappingPickerStatus === "empty" && <Alert bsStyle="info" style={{ marginBottom: 0 }}>
					<strong>No eligible activities found.</strong><br />
					Enable <strong>Pricing Split Screen</strong> on an activity in this organization, then reopen this picker.
				</Alert>}

				{skuPhotoMappingPickerStatus === "error" && <Alert bsStyle="danger" style={{ marginBottom: 0 }}>
					<strong>Activities unavailable.</strong><br />
					{skuPhotoMappingPickerError || "The activity list could not be checked."}
				</Alert>}

				{skuPhotoMappingPickerStatus === "ready" && <div>
					{skuPhotoMappingPickerWarning && <Alert bsStyle="warning">
						{skuPhotoMappingPickerWarning}
					</Alert>}
					<label htmlFor="sku-photo-mapping-activity" style={{ display: "block", marginBottom: 6, fontWeight: 700 }}>
						Activity
					</label>
					<FormControl
						id="sku-photo-mapping-activity"
						componentClass="select"
						value={selectedActivity ? selectedActivity.id : ""}
						onChange={this.handleSkuPhotoMappingActivityChange}
						style={{ width: "100%", marginBottom: 0 }}
					>
						{skuPhotoMappingPickerActivities.length > 1 && <option value="" disabled>
							Select an activity...
						</option>}
						{skuPhotoMappingPickerActivities.map((activity) => <option key={activity.id} value={activity.id}>
							{this.getSkuPhotoMappingActivityOptionLabel(activity)}
						</option>)}
					</FormControl>
					{selectedActivity && <div style={{ marginTop: 10, padding: "10px 12px", border: "1px solid #d8dee4", borderRadius: 6, backgroundColor: "#f8fafc", color: "#52606d", fontSize: 12, lineHeight: 1.4 }}>
						<div>{selectedActivity.description || "This activity is configured to show its SKU catalog in split-screen pricing."}</div>
						{selectedActivityDetails.length > 0 && <div style={{ marginTop: 6 }}>
							{selectedActivityDetails.join(" · ")}
						</div>}
						{selectedActivityTags.length > 0 && <div style={{ marginTop: 4 }}>
							Tags: {selectedActivityTags.join(", ")}
						</div>}
					</div>}
				</div>}

				<div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 20 }}>
					<Button onClick={this.handleCloseSkuPhotoMappingPicker} style={{ marginBottom: 0 }}>Cancel</Button>
					{skuPhotoMappingPickerStatus === "error" && <Button onClick={this.handleRetrySkuPhotoMappingDiscovery} style={{ marginBottom: 0 }}>
						<FontAwesomeIcon icon="sync" /> Retry
					</Button>}
					<Button
						bsStyle="primary"
						onClick={this.handleOpenSkuPhotoMappingWorkbench}
						disabled={skuPhotoMappingPickerStatus !== "ready" || !selectedActivity}
						style={{ marginBottom: 0 }}
					>
						Open workbench
					</Button>
				</div>
			</div>
		</Modal>;
	}

	render() {
		const { showModal } = this.state;
		const skuPhotoMappingAvailable = isSkuPhotoMappingOrganization(this.props.selectedOrgId);
		return (
			<Page title="Drive" subTitle="Manage organization files" showSaveModal={showModal} flexLayout>
				{skuPhotoMappingAvailable && this.renderSkuPhotoMappingPicker()}
				<div style={{ flex: 1, flexGrow: 1, overflow: "hidden" }}>
					<DriveWrapper
						edit={true}
						onOpenSkuPhotoMappingPicker={skuPhotoMappingAvailable
							? this.handleShowSkuPhotoMappingPicker
							: undefined}
					/>
				</div>
			</Page>
		);
	}
	componentDidMount() {
		this.context.tree.select(["appState", "navPanel"]).set("selected", "drive");
	}

	componentDidUpdate(prevProps) {
		if (prevProps.selectedOrgId !== this.props.selectedOrgId && this.state.skuPhotoMappingPickerOpen) {
			this.handleCloseSkuPhotoMappingPicker();
			return;
		}
		if (this.state.skuPhotoMappingPickerOpen
			&& this.state.skuPhotoMappingPickerStatus === "loading"
			&& (prevProps.activitiesLoaded !== this.props.activitiesLoaded || prevProps.activities !== this.props.activities)) {
			this.loadSkuPhotoMappingActivities();
		}
	}

	componentWillUnmount() {
		this.skuPhotoMappingDiscoveryRequestId += 1;
	}
}

DrivePage.contextTypes = {
	tree: PropTypes.baobab
};

export default root(state, branch({
	hierarchy: ["drive", "hierarchy"],
	selectedOrgId: ["selectedOrg", "id"],
	activities: ["activities"],
	activitiesLoaded: ["player", "activitiesLoaded"]
}, DrivePage));
